/**
 * Brazilian real.
 */
export var BRL = {
  code: 'BRL',
  base: 10,
  exponent: 2
};